module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.f7439ba2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Regular/Rubik-Regular.svg
// module id = 1297
// module chunks = 49